import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Dropdown } from 'antd';
import { arrowDownPurple } from 'assets/images';
import { LeadStatus } from 'types/leads';
import LeadStatusButton from './lead-status-button';
import './LeadStatusDropdown.scss';

type Props = {
	highlightedBtns?: LeadStatus[];
	btnDefaultText: string;
	btnTextId: string;
	btnCn?: string;
	closeOnSelect?: boolean;
	onSelect: (value: LeadStatus) => void;
};

const LeadStatusDropdown = ({
	highlightedBtns, btnCn, btnDefaultText, btnTextId, closeOnSelect = true, onSelect,
}: Props): JSX.Element => {
	const [visible, setVisible] = useState<boolean>(false);

	const handleSelect = (value: LeadStatus): void => {
		closeOnSelect && setVisible(false);
		onSelect(value);
	};

	return (
		<Dropdown
			onVisibleChange={setVisible}
			overlay={(
				<div className="lead-status-dropdown">
					<div className="lead-status-btns-wrap">
						{Object.values(LeadStatus).map(status => (
							<div className="lead-status-item-wrap" key={status}>
								<LeadStatusButton
									highlighted={highlightedBtns?.includes(status)}
									onSelect={handleSelect}
									status={status}
								/>
							</div>
						))}
					</div>
				</div>)
			}
			trigger={['click']}
			visible={visible}
		>
			<Button className={`lead-status-dropdown__status-btn ${btnCn ?? ''}`}>
				<div className={'lead-status-dropdown__status'}>
					<FormattedMessage
						defaultMessage={btnDefaultText}
						id={btnTextId}
					/>
					<img alt="" src={arrowDownPurple} />
				</div>
			</Button>
		</Dropdown>

	);
};

export default LeadStatusDropdown;
